import { render, staticRenderFns } from "./MyAgencyDesign.vue?vue&type=template&id=674118cb&scoped=true&"
import script from "./MyAgencyDesign.vue?vue&type=script&lang=js&"
export * from "./MyAgencyDesign.vue?vue&type=script&lang=js&"
import style0 from "./MyAgencyDesign.vue?vue&type=style&index=0&id=674118cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674118cb",
  null
  
)

export default component.exports